import { serverCurrencyToSystemCurrency } from '@wolffun/system-currency';
import { makeAPICaller } from '@vestingSafe/src/utils/fetch';
import { parseVestingSafe, parseVestingSafeConfigResponse } from './utils';
export const getVestingSafeConfigs = makeAPICaller('theta_data_get', '/vesting-safe/configs', response => {
  const {
    data
  } = response || {};
  const {
    gTHG
  } = data || {};
  return {
    status: 'ok',
    body: {
      data: gTHG ? parseVestingSafeConfigResponse(gTHG) : undefined
    }
  };
});
export const getVestingSafe = makeAPICaller('theta_data_get', '/vesting-safe', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: parseVestingSafe(data)
    }
  };
});
export const getVestingSafeRemainingClaimCount = makeAPICaller('theta_data_get', '/vesting-safe/remaining-claim', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: typeof data === 'number' ? data : 0
    }
  };
});
export const postClaimVestingSafe = makeAPICaller('theta_data_post', '/vesting-safe/claim', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: serverCurrencyToSystemCurrency(data)
    }
  };
});